import React, {useMemo} from 'react';
import type { Theme} from '@mui/material';
import {FormLabel} from '@mui/material';
import type {FormLabelOwnProps} from '@mui/material/FormLabel/FormLabel';
import type {SxProps} from '@mui/material/styles';
import type {FieldError, FieldRequiredSimple} from 'schemaDefinition/types';
import {WarningDot} from 'components/dot';
import {Layout} from 'components/layout';

type Props = {
  label: string;
  required?: FieldRequiredSimple;
  error?: FieldError;
  htmlFor?: string;
  colorx?: string;
};

const sxWarningDot: SxProps = {
  marginBottom: '9px',
  marginRight: '4px',
};

export const FieldLabel: React.FC<Props> = ({
  label,
  required = false,
  error = false,
  htmlFor,
  colorx,
}) => {
  const color: FormLabelOwnProps['color'] =
    error && error === 'warning' ? 'warning' : error ? 'error' : undefined;

  const sxs = useMemo((): SxProps | SxProps<Theme> | undefined => {
    return colorx ? {color: colorx} : undefined;
  }, [colorx]);

  return error === 'warning' ? (
    <Layout horizontal alignItems="center" justifyContent="start">
      <WarningDot sx={sxWarningDot} />
      <FormLabel
        htmlFor={htmlFor}
        required={required === true}
        color={color}
        sx={sxs}>
        {label}
      </FormLabel>
    </Layout>
  ) : (
    <FormLabel
      htmlFor={htmlFor}
      required={required === true}
      color={color}
      sx={sxs}>
      {label}
    </FormLabel>
  );
};
